import { Radio, RadioGroup } from '@headlessui/react'
import { FaCheckCircle } from 'react-icons/fa'
import { useId } from 'react'

export function RadioCardGroup({ items, selected, onChange }) {
    const groupId = useId()

    return (
        <div className='w-full px-4'>
            <div className='w-full max-w-md mx-auto'>
                <RadioGroup
                    by='name'
                    value={selected}
                    onChange={onChange}
                    aria-labelledby={groupId}
                    // className='space-x-1 space-y-1'
                >
                    {items.map(plan => (
                        <Radio key={plan.name} value={plan}>
                            {({ checked }) => (
                                <div
                                    className={`group relative flex cursor-pointer rounded-lg border px-5 py-4 shadow-sm transition mb-2 ${
                                        checked
                                            ? 'border-yellow-500 ring-1 ring-yellow-500'
                                            : 'border-gray-300'
                                    } bg-white hover:border-yellow-500 focus:outline-none`}
                                >
                                    <div className='flex items-center justify-between w-full'>
                                        <div className='text-sm'>
                                            <p className='font-semibold text-gray-900'>
                                                {plan.name}
                                            </p>
                                            <div className='mt-1 text-sm text-gray-500'>
                                                {typeof plan.description === 'string' ? (
                                                    <p>{plan.description}</p>
                                                ) : (
                                                    plan.description
                                                )}
                                            </div>
                                        </div>
                                        <FaCheckCircle
                                            className={`size-5 transition ${
                                                checked
                                                    ? 'text-yellow-500 opacity-100'
                                                    : 'opacity-0'
                                            }`}
                                        />
                                    </div>
                                </div>
                            )}
                        </Radio>
                    ))}
                </RadioGroup>
            </div>
        </div>
    )
}
